import React, { useMemo } from 'react'
import { Grid, Card, CardContent, Typography, Theme } from '@material-ui/core'

import {
    Folder,
    TemplateServiceVendor,
    TemplateWorkorder,
} from '../../../../models'
import { useTemplateScheduleGanttStyles } from '../../styles'

interface Props {
    templateVendor: TemplateServiceVendor
    infrastructure: Folder
    theme: Theme
    templateWorkorders?: TemplateWorkorder[]
}

export const TemplateVendorRow = (props: Props) => {
    const { theme, templateVendor, templateWorkorders = [] } = props
    const classes = useTemplateScheduleGanttStyles()

    const avgServiceAreasPerDay = useMemo(() => {
        const vendorWorkorders = templateWorkorders.filter(
            (wo) => wo.template_service_vendor === templateVendor.id,
        )

        const totalServiceAreas = vendorWorkorders.reduce(
            (sum, wo) => sum + (wo.service_areas?.length ?? 0),
            0,
        )

        const uniqueDays = new Set(
            vendorWorkorders.map((wo) => wo.start_date.slice(0, 10)),
        )

        return uniqueDays.size > 0 ? totalServiceAreas / uniqueDays.size : 0
    }, [templateWorkorders, templateVendor.id])

    return (
        <Grid xs={12} container className={classes.vendorRowContainer}>
            <Card className={classes.vendorRowCard}>
                <CardContent className={classes.vendorRowCardContent}>
                    <Typography
                        variant="body1"
                        style={{
                            fontWeight: theme.typography.fontWeightMedium,
                            color: theme.palette.text.primary,
                        }}
                    >
                        {templateVendor.vendor.name}
                    </Typography>
                    <Typography
                        variant="body2"
                        style={{
                            color: theme.palette.text.secondary,
                            lineHeight: 1.4,
                            display: 'flex',
                            justifyContent: 'space-between',
                            width: '100%',
                        }}
                    >
                        <span>Avg SA / Day:</span>
                        <strong style={{ fontSize: '0.95rem' }}>
                            {avgServiceAreasPerDay.toFixed(1)}
                        </strong>
                    </Typography>
                </CardContent>
            </Card>
        </Grid>
    )
}
